import React from 'react';
import styles from './PoliciesStaticPage.css';
import StaticNavigation from './StaticNavigation';

const PoliciesStaticPage = () => ({
  render() {
    return (
      <div>
        <StaticNavigation title="Our Policies" />
        <div className={styles.container}>
          <div className={styles.policySection}>
            <h1 className={styles.header}>Shipping Policy:</h1>
            <ul className={styles.shippingList}>
              <li>
                Prescriptions shipping from the Roadrunner pharmacy will receive
                FREE 2 day shipping.
              </li>
              <li>
                Prescriptions shipping from Covetrus will receive FREE 5 - 7 day
                shipping.
              </li>
            </ul>
          </div>

          <div className={styles.policySection}>
            <h1 className={styles.header}>Return Policy:</h1>
            <p>
              We are committed to quality control and quality assurance for all
              prescriptions. Your satisfaction is very important to us. Please
              note that Covetrus cannot accept returns of prescription products
              for re-use or re-sale. However, if there was an error in filling
              your prescription, we will assist you in finding an acceptable
              solution. Please call Customer Service at 888-606-3336 M-F
              8AM-8PM, Sat. 9AM-2PM CST for assistance.
            </p>
          </div>

          <div className={styles.policySection}>
            <h1 className={styles.header}>Privacy Policy:</h1>
            <p>
              Our user’s privacy is extremely important to us. You can read our{' '}
              <a
                href="https://d2gdm6lfmduyqo.cloudfront.net/documents/covetrus/PrivacyPolicy.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                full privacy policy here
              </a>.
            </p>
          </div>

          <div className={styles.policySection}>
            <h1 className={styles.header}>Terms of Service:</h1>
            <p>
              If you would like to know more about our{' '}
              <a
                href="https://d2gdm6lfmduyqo.cloudfront.net/documents/covetrus/TermsOfService.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service please click here
              </a>.
            </p>
          </div>
          <p>&nbsp;</p>
        </div>
      </div>
    );
  },
});

export default PoliciesStaticPage;



// WEBPACK FOOTER //
// ./src/components/StaticPages/PoliciesStaticPage.jsx